import React from "react";
import {Button} from "reactstrap";

export default function QuestionActions({
  isEditing,
  onUpdate,
  onCancel,
  onEdit,
  onDelete,
  row,
  disableUpdate = false,
  hideEdit = false,
}) {
  return (
    <div style={{ display: "flex", gap: 12, alignItems: "center" }}>
      {isEditing ? (
        <>
          <Button
            color="success"
            size="sm"
            onClick={() => onUpdate(row)}
            disabled={disableUpdate}
          >
            Update
          </Button>
          <Button color="secondary" size="sm" onClick={onCancel}>
            Cancel
          </Button>
        </>
      ) : (
        <>
          {!hideEdit && (
              <Button
                  onClick={() => onEdit(row)}
                  color="default"
                  size="sm"
              >
                <i className="fas fa-pen"/>
              </Button>
              // <i
              //   className="fas fa-edit"
              //   style={{ cursor: "pointer", color: "#007bff", fontSize: 18 }}
              //   title="Edit"
              //   onClick={() => onEdit(row)}
              // />
          )}
          <Button
              onClick={() => onDelete(row)}
              color="danger"
              size="sm"
          ><i className="fas fa-trash"/>
          </Button>
          {/*<i*/}
          {/*  className="fas fa-ban delete-icon"*/}
          {/*  title="Delete"*/}
          {/*  onClick={() => onDelete(row)}*/}
          {/*/>*/}
        </>
      )}
    </div>
  );
}
